export const BASE_CLASS_NAME = 'carousel-informative'
export const MOBILE_QUERY = '(max-width: 48em)'
export const DESKTOP_QUERY = '(min-width: 48em)'
